<template>
  <div class="container container_com-fundo card-dados card-dados_proponente">
    <h2 class="titulo titulo_grande u-margem-inferior-media">
      Dados do proponente
    </h2>

    <div class="conteudo-proponentes">
      <div
        v-for="(proponente, index) in proponentes"
        :key="'proponente-' + index"
      >
        <proponente-item :proponente="proponente" :ordem="index + 1" />

        <hr
          v-if="index < proponentes.length - 1"
          class="separador-proponentes"
        />
      </div>
    </div>

    <div class="linha-de-dados_resumo-renda">
      <span class="item-de-dado_resumo">
        Renda familiar apurada: {{ rendaTotalComprovada || "NÃO INFORMADO" }}
      </span>
      <span class="item-de-dado_resumo">
        Somatório de renda: {{ rendaTotal || "NÃO INFORMADO" }}
      </span>
    </div>
  </div>
</template>

<script>
import ProponenteItem from "./ProponenteItem";

export default {
  name: "dados-do-proponente",
  components: { ProponenteItem },
  props: {
    proponentes: { type: Array, default: () => [] },
    rendaTotal: { type: String, default: null },
    rendaTotalComprovada: { type: String, default: null },
  },
};
</script>



// WEBPACK FOOTER //
// DadosDoProponente.vue?08fac3bc